export enum ChatMessageType {
    InstantMessage,
    InstantMessageFromToast,
    ParticipantJoin,
    ParticipantLeave,
    FailedDelivery,
    DeliveryTimeout,
}

export default interface ChatMessageViewState {
    sequence: number;
    messageType: ChatMessageType;
    fromSipUri: string;
    message: string;
    timestamp: number;
}
